import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/auth";
import { I18nProvider } from "@/i18n";
import { CurrencyProvider } from "@/currency";
import { CountryProvider } from "@/country";
import { ShowPricesProvider } from "@/showPrices";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import InstalledBase from "@/pages/InstalledBase";
import Opportunities from "@/pages/Opportunities";
import AccountPlans from "@/pages/AccountPlans";
import Pipeline from "@/pages/Pipeline";
import Visits from "@/pages/Visits";
import Contacts from "@/pages/Contacts";
import Prices from "@/pages/Prices";
import Competitors from "@/pages/Competitors";
import TurkeyMap from "@/pages/TurkeyMap";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Objectives from "@/pages/Objectives";
import ContactDetail from "@/pages/ContactDetail";
import OperatorProfile from "@/pages/OperatorProfile";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CountryProvider>
          <CurrencyProvider>
            <ShowPricesProvider>
            <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="installed-base" element={<InstalledBase />} />
              <Route path="opportunities" element={<Opportunities />} />
              <Route path="account-plans" element={<AccountPlans />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="objectives" element={<Objectives />} />
              <Route path="visits" element={<Visits />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="contacts/:id" element={<ContactDetail />} />
              <Route path="operators/:name" element={<OperatorProfile />} />
              <Route
                path="prices"
                element={
                  <ProtectedRoute role="admin">
                    <Prices />
                  </ProtectedRoute>
                }
              />
              <Route path="competitors" element={<Competitors />} />
              <Route path="map" element={<TurkeyMap />} />
              <Route
                path="settings"
                element={
                  <ProtectedRoute role="admin">
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin"
                element={
                  <ProtectedRoute role="admin">
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
            </BrowserRouter>
            </ShowPricesProvider>
          </CurrencyProvider>
        </CountryProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
